"use client";

import { useSyncExternalStore } from "react";

const REQUEST_LIFETIME_MS = 60_000;

export type ListingCheckoutRequest = { path: string; quantity: number; requestedAt: number };

let pending: ListingCheckoutRequest | null = null;
const listeners = new Set<() => void>();

function publish(next: ListingCheckoutRequest | null): void {
  pending = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestListingCheckout(path: string, quantity: number): void {
  publish({ path, quantity, requestedAt: Date.now() });
}

export function cancelListingCheckout(): void {
  if (pending) publish(null);
}

export function cancelListingCheckoutAwayFrom(path: string): void {
  if (pending && pending.path !== path) publish(null);
}

export function pendingListingCheckout(path: string): ListingCheckoutRequest | null {
  if (!pending) return null;
  if (Date.now() - pending.requestedAt > REQUEST_LIFETIME_MS) {
    pending = null;
    return null;
  }
  return pending.path === path ? pending : null;
}

export function takeListingCheckoutRequest(path: string, quantity: number): boolean {
  const request = pendingListingCheckout(path);
  if (!request || request.quantity !== quantity) return false;
  pending = null;
  return true;
}

export function useListingCheckoutRequest(): ListingCheckoutRequest | null {
  return useSyncExternalStore(subscribe, () => pending, () => null);
}
